const LANGUAGE_ALIASES = {
  gr: 'el',
  rs: 'sr'
}

export function languageFromLocale (locale) {
  const language = String(locale || 'en').split(/[-_]/)[0].toLowerCase()
  return LANGUAGE_ALIASES[language] || language || 'en'
}

export function selectPluralForm (forms, count, locale) {
  if (typeof forms === 'string') return forms
  if (!forms || typeof forms !== 'object') return ''

  const n = Number(count)
  const safeCount = Number.isFinite(n) ? n : 0
  let category = 'other'

  try {
    category = new Intl.PluralRules(languageFromLocale(locale)).select(safeCount)
  } catch (error) {
    category = new Intl.PluralRules('en').select(safeCount)
  }

  return forms[category] || forms.other || forms.one || ''
}
